import React, { useEffect, useState } from "react";
import DialogWrapper from "./DialogWrapper";
import { ModelMatrixWrapper } from "./styled/StyledModelMatrix.styled";
import ModalMatrixTable from "./ModalMatrixTable";
import StyledButton from "./elements/StyledButton";
import { MdLibraryAdd } from "react-icons/md";

export default function ModelMatrix({
  open,
  setOpen,
  modelMatrixData,
  checkVersion,
  handleAddClickModel,
}) {
  const [order, setOrder] = useState({ id: 1, sort: "asc" });
  const [matrixData, setMatrixData] = useState([]);
  const CountryNamesForTableHeader = [
    { id: 1, label: "Malaysia", sorting: false },
    { id: 1, label: "Bangladesh", sorting: false },
    { id: 1, label: "Sri Lanka", sorting: false },
    { id: 1, label: "Pakistan", sorting: false },
    { id: 1, label: "Cambodia", sorting: false },
    { id: 1, label: "Thailand", sorting: false },
    { id: 1, label: "Phillipines", sorting: false },
  ];
  useEffect(() => {
    setMatrixData(modelMatrixData);
  }, [modelMatrixData]);

  const countryCheck = (event) => {
    checkVersion(event);
  };

  return (
    <DialogWrapper
      title={"Module Matrix"}
      cancelLabel="Cancel"
      actionLabel={"Save Changes"}
      open={open}
      setOpenModal={setOpen}
      nonAction
      acceptButton={() => {}}
      cancelAction={() => {
        setOpen(false);
      }}
      onClose={() => {
        setOpen(false);
      }}
    >
      <ModelMatrixWrapper>
        <ModalMatrixTable
          headCells={[
            {
              id: CountryNamesForTableHeader.length + 1,
              label: "Module",
              sorting: false,
            },
            ...CountryNamesForTableHeader,
          ]}
          rows={matrixData}
          order={order}
          setOrder={setOrder}
          countryCheck={countryCheck}
        />
        <StyledButton
          iconLeft={<MdLibraryAdd />}
          variant={"outlined"}
          onClick={handleAddClickModel}
        >
          Add New Module
        </StyledButton>
      </ModelMatrixWrapper>
    </DialogWrapper>
  );
}
